<template>
    <div class="session_timeout" @click="resetSession">
        <el-tooltip placement="bottom" :open-delay="500" :content="$t('session.countdown.tooltip')">
            <div class="flex flex_column flex_center">
                <span class="session_text">{{ $t('session.countdown.title') }}</span>
                <span class="session_time" :class="timeLeftClass">{{ timeLeftText }}</span>
            </div>
        </el-tooltip>
    </div>
</template>

<script>

import {commonApi} from "@/common/api/commonApi";
import {mapGetters} from "vuex";
import Swal from "sweetalert2";

export default {
    data() {
        return {
            timeLeftClass: "default",
            timeLeftText: "",
            swalAlert: Swal
        };
    },
    mounted() {
        this.updateTimer();
    },
    methods: {
        resetSession() {
            // Send any request to update the session timeout
            commonApi.Currentuser()
                .catch(e => {
                    this.toast(e);
                });
        },
        swalTimeoutReminder() {
          let refreshIntervalId = setInterval(() => {
            this.swalAlert.update({
              html: this.$t('common.session.expiring', { seconds: this.timeLeftText })
            })
          }, 1000)

          this.swalAlert.fire({
            title: '<i class="fa fa-warning" style="padding-top: 18px;margin-right: 10px"></i>' +
                this.$t('common.session.warning'),
            html: this.$t('common.session.expiring', { seconds: this.timeLeftText }),
            type: '',
            confirmButtonText: this.$t('signUp.Continue'),
            confirmButtonClass: "md-primary",
            buttonsStyling: true,
            allowOutsideClick: false
          }).then(result => {
            if (result.value) {
              this.resetSession();
              clearInterval(refreshIntervalId);
            }
          });
        },
        updateTimer() {
            let remainingSecondsTillLogout = this.getCookie("session-timeout") - moment().unix();

            this.timeLeftText = this.calculateDisplayValueFromSeconds(remainingSecondsTillLogout);

            if (this.isLoggedIn) {
              if (remainingSecondsTillLogout === 1) {
                this.swalAlert.close();
              }
              if (remainingSecondsTillLogout <= 0) {
                this.logout();
              } else {
                if (remainingSecondsTillLogout < 300) {
                  this.timeLeftClass = "highlight";
                } else {
                  this.timeLeftClass = "default";
                }
                if (remainingSecondsTillLogout === 15) {
                  this.swalTimeoutReminder();
                }
              }
            }

            setTimeout(function() {
                this.updateTimer();
            }.bind(this), 1000);

        },

        calculateDisplayValueFromSeconds(secondsLeft) {
            var minutes = Math.floor(secondsLeft / 60);

            var seconds;
            if (secondsLeft % 60 === 0) {
                seconds = '00';
            } else if (secondsLeft % 60 < 10 ) {
                seconds = '0' + secondsLeft % 60;
            } else {
                seconds = secondsLeft % 60;
            }

            return minutes + ':' + seconds;
        },
    },
  computed: {
    ...mapGetters(["isLoggedIn"]),
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/base_variables.scss";

.session_timeout {
    margin-right: -1rem;
    margin-top: -15px;
    cursor: pointer;

    .session_text {
        font-size: $font-smaller;
        color: $text-secondary-color;
        margin-bottom: -5px;
    }

    .session_time {
        &.default {
            color: $text-secondary-color;
        }
        &.highlight {
            color: $invalid-color;
        }
    }
}
</style>